<template>
  <v-dialog v-model="computedIsVisible" persistent max-width="768">
    <v-card>
      <v-card-title class="headline">{{ $i18n.t(`dashboard.projects.table.attachments`) }}</v-card-title>
      <v-card-text>
        <v-row class="overflow-y-auto" no-gutters>
          <v-col v-if="offer.hasAttachments" xs="12" style="height: 100%">
            <AttachmentsTable
              :entity-id="offer.id"
              entity-type="offer"
              :has-deleting="false"
              :restriction="restriction"
            />
          </v-col>
          <v-col v-else xs="12" style="height: 100%">
            {{ $i18n.t(`dashboard.projects.table.noAttachments`) }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn color="primary" text @click="close">{{ $i18n.t('default.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {
    AttachmentsTable: () => import('@/components/AttachmentsTable')
  },
  props: {
    offer: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isVisible: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    restriction: {
      type: String
    }
  },
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      }
    }
  },
  methods: {
    close() {
      this.computedIsVisible = false;
    }
  }
};
</script>